/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';

import React, {PureComponent} from 'react';
import * as Colors from 'material-ui/styles/colors';
import {ListItem} from 'material-ui/List';
import IconMenu from 'material-ui/IconMenu';
import CustomSvgIconNew from 'crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIconNew';
import {Link} from 'react-router';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import _ from 'lodash';
import TextBubble from 'shared/components/TextBubble';

const styles = require('./LeftMenuItemStyle.scss');

export default class LeftMenuItem extends PureComponent {
  static propTypes = {
    hiddenMenuElements: PropTypes.shape({
      menuIcon: PropTypes.element,
      menuItems: PropTypes.arrayOf(PropTypes.element),
    }),
    selected: PropTypes.bool,
    showRightIconMenuHover: PropTypes.bool,
    to: Link.propTypes.to,
    innerDivStyle: PropTypes.object,
    count: PropTypes.number,
    uppercase: PropTypes.bool,
    ellipsis: PropTypes.bool,
  };

  static defaultProps = {
    hiddenMenuElements: null,
    showRightIconMenuHover: true,
    toolTip: '',
    tooltipStyle: {
      maxWidth: 'auto',
      padding: '0 8px',
      fontSize: '10px',
      lineHeight: '22px',
    },
    ellipsis: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      iconHover: false,
      showMenu: false,
      textOverflowing: false,
    };
  }

  componentDidMount() {
    window.requestAnimationFrame(() => {
      const {ellipsis} = this.props;
      const {innerDiv} = this;
      if (ellipsis && innerDiv && innerDiv.scrollWidth > innerDiv.clientWidth) {
        this.setState({textOverflowing: true});
      } else {
        this.setState({textOverflowing: false});
      }
    });
  }

  getStyle() {
    return this.props.selected
      ? {
          borderLeft: `4px solid ${Colors.lightGreen700}`,
          backgroundColor: Colors.grey300,
          color: Colors.grey800,
          cursor: 'pointer',
        }
      : {
          color: Colors.grey700,
          borderLeft: `4px solid ${Colors.transparent}`,
          zIndex: 1,
        };
  }

  getRightMenuItem({menuIcon, menuItems}) {
    return (
      <IconMenu
        iconButtonElement={React.cloneElement(
          menuIcon,
          this.props.toolTip
            ? {
                onMouseEnter: () => this.setState({iconHover: true}),
                onMouseLeave: () => this.setState({iconHover: false}),
              }
            : {}
        )}
        className={
          this.props.showRightIconMenuHover ? `${styles.hiddenIcon} ${this.state.showMenu ? styles.active : ''}` : null
        }
        clickCloseDelay={0}
        anchorOrigin={{horizontal: 'left', vertical: 'top'}}
        targetOrigin={{horizontal: 'left', vertical: 'top'}}
        open={this.state.showMenu}
        onRequestChange={open => this.setState({showMenu: open})}
        onItemClick={() => this.setState({showMenu: false})}
        useLayerForClickAway
      >
        {menuItems}
      </IconMenu>
    );
  }

  getPrimaryText() {
    const {nestedItems, count, leftIcon, iconPath, hiddenMenuElements, uppercase, ellipsis, id} = this.props;
    const textId = id ? id.replace('menuitem', 'menuitem-text') : null;
    let {primaryText} = this.props;
    if (!React.isValidElement(primaryText)) {
      primaryText = <div>{primaryText}</div>;
    }
    const primaryTextChildren = React.Children.toArray(primaryText.props.children);
    if (!_.isNil(count)) {
      primaryTextChildren.push(<TextBubble className="cla-listing-count" key="count" text={count} />);
    }
    const primaryTextStyle = {
      position: 'relative',
      paddingTop: 16,
      paddingBottom: 16,
    };
    if (nestedItems) {
      primaryTextStyle.paddingRight = 23;
    }
    let ref;
    if (ellipsis) {
      primaryTextStyle.overflow = 'hidden';
      primaryTextStyle.textOverflow = 'ellipsis';
      ref = ref => {
        if (ref) this.innerDiv = ref;
      };
    }
    if (uppercase) {
      primaryTextStyle.textTransform = 'uppercase';
    }
    if (leftIcon || iconPath) {
      primaryTextStyle.left = -20;
    }
    primaryText = React.createElement(
      'div',
      {
        ...primaryText.props,
        ref,
        className: `${styles.leftMenuText} ${hiddenMenuElements ? styles.slideOnHover : ''}`,
        style: {...primaryText.props.style, ...primaryTextStyle},
        id: textId,
      },
      primaryTextChildren
    );
    return primaryText;
  }

  render() {
    const {
      to,
      selected,
      iconPath,
      onClick,
      rightIconButton,
      showRightIconMenuHover,
      uppercase,
      ellipsis,
      hiddenMenuElements,
      children,
      toolTip,
      tooltipStyle,
      style,
      count,
      primaryText,
      id,
      ...other
    } = this.props;
    const {textOverflowing} = this.state;
    const addProps = {};
    const iconId = id ? id.replace('menuitem', 'menuitem-icon') : null;
    if (to) {
      addProps.containerElement = <Link to={to} />;
    }
    return (
      <ListItem
        id={id}
        className={styles.leftMenuItem}
        style={{...this.getStyle(), ...style}}
        ref="menu"
        innerDivStyle={{paddingTop: 0, paddingBottom: 0}}
        leftIcon={iconPath ? <CustomSvgIconNew id={iconId} path={iconPath} /> : null}
        onClick={onClick}
        rightIconButton={hiddenMenuElements ? this.getRightMenuItem(hiddenMenuElements) : rightIconButton}
        {...other}
        {...addProps}
      >
        <TooltipWrapper
          tooltip={textOverflowing ? primaryText : toolTip}
          popoverType="grey"
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          tooltipStyle={tooltipStyle}
        >
          {this.getPrimaryText()}
          {children}
        </TooltipWrapper>
      </ListItem>
    );
  }
}
